import React from 'react'
import { Pressable, Text, View } from 'react-native'

import { bgColor, textColor } from '@ui-kit/styles/colors'

import * as styles from './styles'
import type { NativeProps } from './types'

const Avatar = (props: NativeProps): JSX.Element => {
  const { container, circle, initials, textContainer, iconContainer, subtitle, title } =
    styles.avatar({ interactive: Boolean(props.onPress), size: props.size })
  return (
    <Pressable className={container()} key={props.id} testID={props.id} onPress={props.onPress}>
      <View className={circle({ className: bgColor({ color: props.bgColor ?? 'uiGreyLight' }) })}>
        <Text
          className={initials({
            className: textColor({ color: props.initialsColor ?? 'brandDark' }),
          })}
        >
          {props.initials}
        </Text>
        {props.icon && <View className={iconContainer()}>{props.icon}</View>}
      </View>
      {(props.title || props.subtitle) && (
        <View className={textContainer()}>
          {props.title && <Text className={title()}>{props.title}</Text>}
          {props.subtitle && <Text className={subtitle()}>{props.subtitle}</Text>}
        </View>
      )}
    </Pressable>
  )
}

export default Avatar
